import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { BoxInfoRouterService } from '../box-info-router/box-info-router.service';
import { ConfiguracaoInfoCliente, StatusRoteiroPedidos, Util } from '../shared/Util';
import { NotificationService } from '../shared/notification.service';
import { FormsModule } from '@angular/forms';
import { NgFor, NgIf, SlicePipe } from '@angular/common';
declare let jsPDF;

// Constantes do layout do PDF
const PDF_WIDTH_MM = 297;
const PDF_HEIGHT_MM = 260;
const PDF_MARGIN = 8;
const PDF_CONTENT_WIDTH = PDF_WIDTH_MM - (PDF_MARGIN * 2);
const PX_PER_INCH = 96;
const MM_PER_INCH = 25.4;
const SCALE_MIN = 0.7;

@Component({
    selector: 'app-popup-download-todos-comprovantes',
    templateUrl: './popup-download-todos-comprovantes.component.html',
    styleUrls: ['./popup-download-todos-comprovantes.component.css'],
    standalone: true,
    imports: [FormsModule, NgFor, NgIf, SlicePipe]
})
export class PopupDownloadTodosComprovantesComponent {

    listaRoteiroCliente: any[] = [];
    aceitarTermos: boolean;
    @Input() listaRoteiroClientes: any
    entregasPossuiConfirmacao: any;
    itensSelecionados: any[] = [];
    entregasComComprovante = [];
    todosSelecionados = true;
    abrirModalDownload = false;
    isDownloading = false;
    configNomeClienteExibicao = ConfiguracaoInfoCliente.RazaoSocial;
    enumConfiguracaoInfoCliente = ConfiguracaoInfoCliente;
    comprovanteVisualizado: { cliente: any; imagem: string } | null = null;

    private selecionadosSet = new Set<any>();

    constructor(private boxInfoRouterService: BoxInfoRouterService, public notificationService: NotificationService, private cdr: ChangeDetectorRef) { }

    ngOnInit() {
        this.verificaConfNomeClienteExib();
        this.entregasPossuiConfirmacao = this.listaRoteiroClientes.filter(item =>
            item.pedidos?.some(pedido => pedido.IdPedidoConfirmacaoEntrega != null)
        );
        this.itensSelecionados = [...this.entregasPossuiConfirmacao];
        this.selecionadosSet = new Set(this.itensSelecionados);
        this.exibirImagemComprovante();
    }


    async exibirImagemComprovante() {
        this.entregasComComprovante = [];
        for (let index = 0; index < this.entregasPossuiConfirmacao.length; index++) {
            const entregas = this.entregasPossuiConfirmacao[index];

            const pedidoComConfirmacao = entregas.pedidos.find(p => p.IdPedidoConfirmacaoEntrega != null);

            if (!pedidoComConfirmacao) continue;

            this.boxInfoRouterService.getComprovante(pedidoComConfirmacao.IdPedidoConfirmacaoEntrega)
                .then(item => {
                    const imagem = Util.decompress(item.Arquivo);

                    this.entregasComComprovante[index] = {
                        ...entregas,
                        ...item,
                        imagem
                    };
                    this.cdr.detectChanges?.();
                })
                .catch(err => console.error(err));
        }
    }

    async fazerDownload() {
        if (!this.itensSelecionados || this.itensSelecionados.length === 0) {
            this.notificationService.showErro("Nenhum cliente selecionado");
            return;
        }

        this.isDownloading = true;
        this.abrirModalDownload = true;

        this.itensSelecionados.forEach(item => {
            (item as any).statusDownload = 'baixando';
        });

        for (let entrega of this.itensSelecionados) {
            try {
                const pedidoComConfirmacao = entrega.pedidos.find(pedido => pedido.IdPedidoConfirmacaoEntrega != null);

                if (pedidoComConfirmacao) {
                    const item = await this.boxInfoRouterService.getComprovante(pedidoComConfirmacao.IdPedidoConfirmacaoEntrega);
                    const entregaComDados = { ...entrega, ...item };

                    const imagem = Util.decompress(entregaComDados.Arquivo);
                    await this.gerarPdfComprovante(entregaComDados, imagem);
                    (entrega as any).statusDownload = 'concluido';
                }
            } catch (err) {
                console.error('Erro ao processar item:', entrega, err);
            }
        }

        this.isDownloading = false;
        setTimeout(() => {
            this.abrirModalDownload = false;
        }, 3000);
    }

    private fixOrientation(base64: string): Promise<string> {
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = function () {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext('2d')!;
                ctx.drawImage(img, 0, 0);
                resolve(canvas.toDataURL('image/jpeg'));
            };
            img.src = base64;
        });
    }

    isSelecionado(item: any): boolean {
        return this.selecionadosSet.has(item);
    }

    abrirVisualizacaoComprovante(cliente: any, comprovante: any): void {
        this.comprovanteVisualizado = {
            cliente: { ...cliente, ...comprovante },
            imagem: comprovante.imagem
        };
    }

    // Fecha a modal de visualização
    fecharVisualizacaoComprovante(): void {
        this.comprovanteVisualizado = null;
    }

    // Download apenas do comprovante visualizado (em PDF, mesmo formato do download em lote)
    async fazerDownloadIndividual(comprovante: { cliente: any; imagem: string }): Promise<void> {
        const entrega = comprovante.cliente;
        const imagem = comprovante.imagem;
        await this.gerarPdfComprovante(entrega, imagem);
    }

    /**
     * Calcula as dimensões e posição da imagem para encaixar no PDF
     * respeitando as proporções e limites do documento.
     */
    private calcularDimensoesImagem(imgWidth: number, imgHeight: number, alturaImagem: number) {
        const pdfMaxHeight = PDF_HEIGHT_MM - (alturaImagem + 10) - 10;
        const posX = PDF_MARGIN;
        const posY = alturaImagem + 10;

        const imgWidthMM = (imgWidth * MM_PER_INCH) / PX_PER_INCH;
        const imgHeightMM = (imgHeight * MM_PER_INCH) / PX_PER_INCH;

        const scaleWidth = PDF_CONTENT_WIDTH / imgWidthMM;
        const scaleHeight = pdfMaxHeight / imgHeightMM;

        let scale = Math.min(scaleWidth, scaleHeight);
        scale = Math.max(scale, SCALE_MIN);

        if (imgWidthMM * scale > PDF_CONTENT_WIDTH) {
            scale = PDF_CONTENT_WIDTH / imgWidthMM;
        }
        if (imgHeightMM * scale > pdfMaxHeight) {
            scale = pdfMaxHeight / imgHeightMM;
        }

        const finalWidth = imgWidthMM * scale;
        const finalHeight = imgHeightMM * scale;
        const finalPosX = finalWidth < PDF_CONTENT_WIDTH ? posX + (PDF_CONTENT_WIDTH - finalWidth) / 2 : posX;

        return { finalWidth, finalHeight, finalPosX, posY };
    }

    /**
     * Carrega uma imagem base64 e retorna suas dimensões naturais via Promise.
     */
    private carregarImagem(src: string): Promise<HTMLImageElement> {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => resolve(img);
            img.onerror = reject;
            img.src = src;
        });
    }

    // Método compartilhado para gerar PDF no formato padrão
    private async gerarPdfComprovante(entrega: any, imagem: string): Promise<void> {
        const imgData = 'data:image/jpeg;base64,' + imagem;

        const doc = new jsPDF('l', 'mm', [PDF_WIDTH_MM, PDF_HEIGHT_MM]); // paisagem
        const titulos = 16, informacaoes = 26, data = 26;
        let alturaImagem = 28, numeroNota = 26;

        // Cabeçalho
        doc.setDrawColor(0);
        doc.setFillColor(255, 255, 255);
        doc.text(PDF_MARGIN, titulos, 'DATA');
        doc.setFontType('bold');
        doc.setFontSize(16);
        doc.text(
            PDF_MARGIN,
            data,
            new Date(entrega.dataFinalEntrega).toLocaleString('pt-BR', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            })
        );

        doc.setFontType('normal');
        doc.text(69, titulos, 'IDENTIFICAÇÃO');
        doc.setFontType('bold');
        doc.text(109, informacaoes, entrega.NomeRecebedor.substring(0, 25));
        doc.text(200, informacaoes, entrega.DocumentoRecebedor);
        doc.setFontType('normal');
        doc.text(180, informacaoes, 'DOC.:');
        doc.text(69, informacaoes, 'RECEBEDOR:');
        doc.text(252, titulos, 'NF-E');

        entrega.pedidos.forEach((pedido) => {
            if (pedido.IdRoteiroPedidoSituacao == StatusRoteiroPedidos.EntregaFinalizada) {
                doc.setFontType('normal');
                doc.text(252, numeroNota, `Nº `);
                doc.setFontType('bold');
                doc.text(260, numeroNota, `${pedido.Nf}`);
                numeroNota += 6;
                alturaImagem += 4;
            }
        });

        doc.setFontType('normal');

        // Adiciona imagem ao PDF com fallback JPEG -> PNG
        await this.adicionarImagemAoPdf(doc, imgData, imagem, alturaImagem);

        // Gera nome do arquivo
        const nomeArquivo = entrega.pedidos
            .filter(p => p.IdRoteiroPedidoSituacao == StatusRoteiroPedidos.EntregaFinalizada)
            .map(p => `NF_${p.Nf}`)
            .join('_');

        const nomeCliente = this.configNomeClienteExibicao == this.enumConfiguracaoInfoCliente.NomeFantasia
            ? entrega.NomeFantasia
            : entrega.RazaoSocial;

        doc.save(` ${nomeCliente}_${nomeArquivo}.pdf`);
    }

    /**
     * Tenta adicionar a imagem como JPEG; em caso de falha, tenta como PNG.
     */
    private async adicionarImagemAoPdf(doc: any, imgData: string, imagemBase64: string, alturaImagem: number): Promise<void> {
        try {
            const fixedImg = await this.fixOrientation(imgData);
            const tempImg = await this.carregarImagem(fixedImg);
            const dims = this.calcularDimensoesImagem(tempImg.width, tempImg.height, alturaImagem);

            doc.addImage(fixedImg, 'JPEG', dims.finalPosX, dims.posY, dims.finalWidth, dims.finalHeight);
        } catch (error) {
            console.log('Erro ao adicionar JPEG, tentando PNG');
            const fallbackImg = 'data:image/png;base64,' + imagemBase64;
            const fixedPng = await this.fixOrientation(fallbackImg);
            const tempImg = await this.carregarImagem(fixedPng);
            const dims = this.calcularDimensoesImagem(tempImg.width, tempImg.height, alturaImagem);

            doc.addImage(fixedPng, 'PNG', dims.finalPosX, dims.posY, dims.finalWidth, dims.finalHeight);
        }
    }

    toggleSelecao(item: any, event: Event): void {
        const checked = (event.target as HTMLInputElement).checked;

        if (checked) {
            if (!this.selecionadosSet.has(item)) {
                this.itensSelecionados.push(item);
                this.selecionadosSet.add(item);
            }
        } else {
            this.itensSelecionados = this.itensSelecionados.filter(i => i !== item);
            this.selecionadosSet.delete(item);
        }

        // Atualiza o checkbox principal (Clientes)
        this.todosSelecionados = this.itensSelecionados.length === this.entregasPossuiConfirmacao.length;
    }

    toggleTodos(event: Event): void {
        const checked = (event.target as HTMLInputElement).checked;
        this.todosSelecionados = checked;
        if (checked) {
            this.itensSelecionados = [...this.entregasPossuiConfirmacao];
            this.selecionadosSet = new Set(this.itensSelecionados);
        } else {
            this.itensSelecionados = [];
            this.selecionadosSet.clear();
        }
    }

    fecharModalDownload() {
        this.abrirModalDownload = false;
    }

    fecharModalComprovantes() {
        this.boxInfoRouterService.exibirModalComprovante = false;
        this.abrirModalDownload = false;
    }

    private verificaConfNomeClienteExib() {
        if (!this.listaRoteiroClientes?.length) return;
        const infoRota = JSON.parse(this.listaRoteiroClientes[0].InfoRota || '{}');
        this.configNomeClienteExibicao = infoRota?.ConfigNomeClienteExibicao;
    }
}
